import { Chakra } from "@airhelp/react-ui-components";

import config from "config/config";
import { useTranslations } from "contexts/LocalizationContext/hooks";
import type { SingleLinkProps } from "./FooterSimple.d";

const { Link } = Chakra;

const SingleLink = ({ path, translationKey, isExternal }: SingleLinkProps ) => {
  const translations = useTranslations();

  return (
    <Link
      key={path}
      isExternal={isExternal}
      href={`${config.websiteUrl}${path}`}
      mr={{ md: 14 }}
      color="greyscale.600"
      _hover={{ color: "greyscale.800", textDecoration: "none" }}
      my={4}
      title={translations(translationKey)}
      fontSize="sm"
    >
      {translations(translationKey)}
    </Link>
  );
};

export default SingleLink;
